import { Link, useHistory } from "react-router-dom";
import { Card } from "../../../components/card.component";
import { AppRouteUi } from "../../../config/appRoute";
import { AddPatient } from "../../../features/patient/addPatient.component";
import { SubscribeModal } from "../../../components/subscribeModal.component";

export const PagePatientAdd = () => {
  const routeHistory = useHistory<{ from?: string }>();

  return (
    <>
      <Card
        header={
          <div className="row align-items-center justify-content-between">
            <div className="col content-box-title">
              <div className="d-flex align-items-center">
                <Link
                  to={
                    routeHistory.location.state?.from ||
                    AppRouteUi.Patient.List()
                  }
                  className="pe-2 border-2 border-end"
                >
                  <i className="fas fa-arrow-left text-green-200" />
                </Link>
                <p className="text-capitalize mb-0 ps-2  text-green-200">
                  Add New Patient
                </p>
              </div>
              <div className="collapse-icon"></div>
            </div>
          </div>
        }
      >
        <AddPatient />
      </Card>
      <SubscribeModal />
    </>
  );
};
